<template>
  <el-button
    icon="ico icon-floppy"
    type="primary"
    :disabled="disabled"
    @click="click()"
    data-qa="save-button"
  >
    {{ $t('RestForm_Save') }}
  </el-button>
</template>

<script>
export default {
  name: 'SaveButton',
  props: {
    click: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/form/SaveButton.vue